import LeftMenu from './main.vue'

LeftMenu.install = function (Vue) {
  Vue.component(LeftMenu.name, LeftMenu)
}

export default LeftMenu
